/*
 * @Author: DY
 * @Date: 2021-12-09 10:37:09
 * @LastEditTime: 2026-06-25 10:18:50
 * @Description:
 * @Param:
 * @FilePath: \ConcreteCloud_Mobile\src\assets\js\global_variable.js
 */
// const global = {};
// const FFILE_BASE_URL = ':9000/'; // 开发环境
// const FFILE_BASE_URL = 'http://demo-concrete.cucc.com.cn:9000/'; // 测试环境
// const FFILE_BASE_URL = 'http://concrete.cucc.com.cn:9000/'; // 生产环境
/*
* 符祖昌新增调取PC端项目配置表单
* 打包时注意
* 需对应环境解开注释，操作同上
*/
// const FORM_BASE_URL = 'http://39.106.58.200/'; // 开发web环境ip域名
// const FORM_BASE_URL = 'http://demo-concrete.cucc.com.cn/'; // 测试web环境ip域名
// const FORM_BASE_URL = 'http://concrete.cucc.com.cn/' // 生产web环境ip域名
// 文件服务地址
let FILE_BASE_URL = '';
const getFileBaseUrl = () => {
    const hostUrl = window.location;
    const _path = `${hostUrl.protocol}//files.concrete-cloud.com/`;
    return _path;
};
FILE_BASE_URL = getFileBaseUrl();
// 调取PC端项目配置表单
let FORM_BASE_URL = '';
const getFormBaseUrl = () => {
    let _path = '';
    const hostUrl = window.location;
    if (hostUrl.host === 'mpdev.concrete-cloud.com') {
        _path = `${hostUrl.protocol}//www.concrete-cloud.com/`;
    } else {
        _path = `${hostUrl.protocol}//temp-www.concrete-cloud.com/`;
    }
    return _path;
};
FORM_BASE_URL = getFormBaseUrl();
export default {
    FILE_BASE_URL,
    FORM_BASE_URL,
};
